import { render, staticRenderFns } from "./BillingModifiers.vue?vue&type=template&id=03809f38&scoped=true&"
import script from "./BillingModifiers.vue?vue&type=script&lang=js&"
export * from "./BillingModifiers.vue?vue&type=script&lang=js&"
import style0 from "./BillingModifiers.vue?vue&type=style&index=0&id=03809f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03809f38",
  null
  
)

export default component.exports